import { FC } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { TooltipWrapper } from '@wellesley/ui'
import { Ban, Gauge, Info } from 'lucide-react'
import { BlockedDomain, DomainBlockState } from '@wellesley/openapi'

import LimitTooltipHint from './LimitTooltipHint'

type ModerationBadgeProps = {
  moderation: DomainBlockState
}

const ModerationBadge: FC<ModerationBadgeProps> = ({ moderation }) => {
  const isSuspended = moderation === 'SUSPEND'
  const label = isSuspended ? 'Suspended' : 'Limited'
  const icon = isSuspended ? (
    <Ban size={12} strokeWidth={2} color="var(--red-200)" />
  ) : (
    <Gauge size={12} strokeWidth={2} color="var(--red-200)" />
  )

  return (
    <div className="flex items-center gap-xxxs justify-self-start rounded-sm bg-red-100 p-xxxs text-sm font-semibold text-gray-900">
      {icon}
      {label}
    </div>
  )
}

const domainCell: ColumnDef<BlockedDomain> = {
  accessorKey: 'domain',
  cell: (info) => info.getValue(),
  meta: {
    cellClassName: 'text-base font-semibold ',
  },
  header: () => <span>Domain name</span>,
  footer: (info) => info.column.id,
  enableSorting: false,
  size: 80,
}

const stateCell: ColumnDef<BlockedDomain> = {
  accessorKey: 'state',
  cell: (info) => (
    <ModerationBadge moderation={info.getValue() as DomainBlockState} />
  ),
  header: () => (
    <span className="flex items-center gap-xxxs">
      Moderation
      <TooltipWrapper
        theme="dark"
        size="small"
        tooltipText={<LimitTooltipHint />}
      >
        <Info size={16} color="var(--blue-500)" />
      </TooltipWrapper>
    </span>
  ),
  footer: (info) => info.column.id,
  enableSorting: false,
  size: 65,
}

export const domainAndStateColumns: ColumnDef<BlockedDomain>[] = [
  domainCell,
  stateCell,
]

export const allColumns: ColumnDef<BlockedDomain>[] = [
  ...domainAndStateColumns,
  {
    accessorKey: 'publicComment',
    header: () => 'Reason',
    cell: (info) => info.renderValue(),
    footer: (info) => info.column.id,
    enableSorting: false,
  },
]
